"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockSharedDraft = void 0;
const organization_1 = require("./organization");
const user_1 = require("./user");
const enums_1 = require("../../utilities/enums");
const utils_1 = require("../utils");
const base = Object.assign({ id: 1, organization_id: (0, organization_1.mockChildOrganization)().id, user_id: (0, user_1.mockPreviewUserOne)().id, conversation_id: 1, signature_id: null, account_id: null, ai_request_id: null, source_id: null, subject: "RE: my subject", body: "<p>Subject paragraph</p>", reply_body: null, channel: enums_1.DraftChannelEnum.Mail, reply_to: null, reply_to_address: "", reply_to_cc: [], reply_to_bcc: [], reply_to_phone: null, attachments: [] }, utils_1.mockDateObject);
exports.mockSharedDraft = (0, utils_1.mockFunction)(Object.assign({}, base));
